import React from "react";

// empty
import EmptyPage from "pages/Empty";

// auth
import AuthLayout from "layouts/Auth";
import LoginPage from "pages/auth/Login";
import LoginOtpPage from "pages/auth/LoginOtp";
import ResetPage from "pages/auth/Reset";
import OtpPage from "pages/auth/Otp";

// app
import DefaultLayout from "layouts/Default";
import AboutPage from "pages/default/AboutUs";
import BannersPage from "pages/default/Banners";
import CategoriesPage from "pages/default/Categories";
import ContactPage from "pages/default/ContactUs";
import DashboardPage from "pages/default/Dashboard";
import FaqPage from "pages/default/FAQ";
import JobsPage from "pages/default/Jobs";
import NotificationsPage from "pages/default/Notifications";
import PaymentVerificationPage from "pages/default/PaymentVerification";
import PendingJobsPage from "pages/default/PendingJobs";
import PlatformPage from "pages/default/Platform";
// import ReportsPage from "pages/default/Reports";
import RolesPage from "pages/default/Roles";
import SettingsPage from "pages/default/Settings";
import SpecialJobsPage from "pages/default/SpecialJobs";
import SubscriptionsPage from "pages/default/Subscriptions";
import SupportPage from "pages/default/Support";
import TacPage from "pages/default/TAC";
import TrackerPage from "pages/default/Tracker";
import TransactionsPage from "pages/default/Transactions";
import UsersPage from "pages/default/Users";
import VersionPage from "pages/default/Version";

// errors
import NotFoundPage from "pages/result/NotFound";
import UnAuthorizedPage from "pages/result/UnAuthorized";

import { Permissions } from "scripts/settings";
import Resources from "scripts/resources";

export default [
	// errors
	{
		path: "/403",
		name: "unauthorized",
		component: UnAuthorizedPage,
	},
	{
		path: "/404",
		name: "notfound",
		component: NotFoundPage,
	},
	// authorization
	{
		path: "/auth",
		name: "auth",
		component: AuthLayout,
		routes: [
			{
				path: "/auth",
				name: "loginRedirect",
				redirect: "/auth/login",
			},
			{
				path: "/auth/login",
				name: "login",
				title: Resources.login,
				component: LoginPage,
			},
			{
				path: "/auth/reset",
				name: "reset",
				title: Resources.passwordRecovery,
				component: ResetPage,
			},
			{
				path: "/auth/get-otp",
				name: "getOtp",
				title: Resources.getOtp,
				component: OtpPage,
			},
			{
				path: "/auth/login-otp",
				name: "getOtp",
				title: Resources.login,
				component: LoginOtpPage,
			},
		],
	},
	// app
	{
		path: "/",
		name: "app",
		component: DefaultLayout,
		routes: [
			{
				name: "loginRedirect",
				path: "/login",
				redirect: "/auth/login",
			},
			{
				name: "dashboardRedirect",
				path: "/",
				redirect: "/dashboard",
			},
			{
				name: "dashboard",
				icon: <i className="ant-menu-item-icon fa fa-laptop" />,
				path: "/dashboard",
				title: Resources.dashboard,
				component: DashboardPage,
			},
			{
				name: "userManagement",
				icon: <i className="ant-menu-item-icon fa fa-users" />,
				title: Resources.users,
				routes: [
					{
						name: "users",
						icon: <i className="ant-menu-item-icon fa fa-folder" />,
						path: "/users",
						title: Resources.users,
						component: UsersPage,
						authority: Permissions.USER_VIEW,
					},
					{
						name: "roles",
						icon: <i className="ant-menu-item-icon fa fa-folder" />,
						path: "/roles",
						title: Resources.roles,
						component: RolesPage,
						authority: Permissions.ROLE_VIEW,
					},
				],
			},
			{
				name: "businessManagement",
				icon: <i className="ant-menu-item-icon fa fa-industry" />,
				title: Resources.business,
				routes: [
					{
						name: "jobs",
						icon: <i className="ant-menu-item-icon fa fa-folder" />,
						path: "/jobs",
						title: `${Resources.jobs}`,
						component: JobsPage,
						authority: Permissions.JOB_VIEW,
					},
					{
						name: "pendingJobs",
						icon: <i className="ant-menu-item-icon fa fa-folder" />,
						path: "/pending-jobs",
						title: `${Resources.jobs} ${Resources.pending}`,
						component: PendingJobsPage,
						authority: Permissions.JOB_VIEW,
					},
					{
						name: "specialJobs",
						icon: <i className="ant-menu-item-icon fa fa-folder" />,
						path: "/special-jobs",
						title: `${Resources.jobs} ${Resources.special}`,
						component: SpecialJobsPage,
						authority: Permissions.SPECIAL_JOB_VIEW,
					},
					{
						name: "categories",
						icon: <i className="ant-menu-item-icon fa fa-folder" />,
						path: "/categories",
						title: Resources.categories,
						component: CategoriesPage,
						authority: Permissions.CATEGORY_VIEW,
					},
					{
						name: "banners",
						icon: <i className="ant-menu-item-icon fa fa-folder" />,
						path: "/banners",
						title: `${Resources.banner}${Resources.ha}`,
						component: BannersPage,
						authority: Permissions.BANNER_VIEW,
					},
					{
						name: "subscriptions",
						icon: <i className="ant-menu-item-icon fa fa-folder" />,
						path: "/subscriptions",
						title: `${Resources.subscription}${Resources.ha}`,
						component: SubscriptionsPage,
						authority: Permissions.SUBSCRIPTION_VIEW,
					},
					{
						name: "paymentVerification",
						icon: <i className="ant-menu-item-icon fa fa-folder" />,
						path: "/payment-verification",
						title: `${Resources.confirm} ${Resources.pay}${Resources.y}${Resources.ha}`,
						component: PaymentVerificationPage,
						authority: Permissions.PAYMENT_VIEW,
					},
					// {
					// 	name: "transactions",
					// 	icon: <i className="ant-menu-item-icon fa fa-folder" />,
					// 	path: "/transactions",
					// 	title: `${Resources.transaction}${Resources.ha}`,
					// 	component: TransactionsPage,
					// 	authority: Permissions.USER_VIEW,
					// },
				],
			},
			{
				name: "pageManagement",
				icon: <i className="ant-menu-item-icon fa fa-globe" />,
				title: `${Resources.pages} ${Resources.site}`,
				routes: [
					{
						name: "about",
						icon: <i className="ant-menu-item-icon fa fa-folder" />,
						path: "/about",
						title: Resources.aboutUs,
						component: AboutPage,
						authority: Permissions.ABOUT_US_VIEW,
					},
					{
						name: "contact",
						icon: <i className="ant-menu-item-icon fa fa-folder" />,
						path: "/contact",
						title: Resources.contactUs,
						component: ContactPage,
						authority: Permissions.CONTACT_US_VIEW,
					},
					{
						name: "tac",
						icon: <i className="ant-menu-item-icon fa fa-folder" />,
						path: "/tac",
						title: Resources.tac,
						component: TacPage,
						authority: Permissions.TAC_VIEW,
					},
					{
						name: "faq",
						icon: <i className="ant-menu-item-icon fa fa-folder" />,
						path: "/faq",
						title: Resources.faq,
						component: FaqPage,
						authority: Permissions.FAQ_VIEW,
					},
				],
			},
			{
				name: "publicManagement",
				icon: <i className="ant-menu-item-icon fa fa-cogs" />,
				title: Resources.public,
				routes: [
					{
						name: "supportMessages",
						icon: <i className="ant-menu-item-icon fa fa-folder" />,
						path: "/support-messages",
						title: `${Resources.message}${Resources.ha}${Resources.y} ${Resources.support}`,
						component: SupportPage,
						authority: Permissions.SUPPORT_MESSAGE_VIEW,
					},
					{
						name: "tracker",
						icon: <i className="ant-menu-item-icon fa fa-folder" />,
						path: "/tracker",
						title: `${Resources.security}`,
						component: TrackerPage,
						authority: Permissions.TRACKER_VIEW,
					},
					{
						name: "Notifications",
						icon: <i className="ant-menu-item-icon fa fa-folder" />,
						path: "/notifications",
						title: Resources.notifications,
						component: NotificationsPage,
						authority: Permissions.NOTIFICATION_VIEW,
					},
					{
						name: "settings",
						icon: <i className="ant-menu-item-icon fa fa-folder" />,
						path: "/settings",
						title: Resources.settings,
						component: SettingsPage,
						authority: Permissions.SETTING_VIEW,
					},
					{
						name: "platform",
						icon: <i className="ant-menu-item-icon fa fa-folder" />,
						path: "/platform",
						title: Resources.platform,
						component: PlatformPage,
						authority: Permissions.PLATFORM_VIEW,
					},
					{
						name: "version",
						icon: <i className="ant-menu-item-icon fa fa-folder" />,
						path: "/version",
						title: Resources.version,
						component: VersionPage,
						authority: Permissions.VERSION_VIEW,
					},
				],
			},
		],
	},
];
